exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".article-snippet {}\n\n.article-snippet__hint {\n    font-size: 12px;\n\n    margin-bottom: 5px;\n\n    color: rgba(0, 0, 0, 0.3);\n}\n\n.article-snippet__title {\n    font-size: 18px;\n\n    cursor: pointer;\n    text-decoration: underline;\n    color: #1a0dab;\n}\n\n.article-snippet__description {\n    font-size: 13px;\n\n    line-height: 1.4;\n    word-wrap: break-word;\n    color: #545454;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"importLoaders":1}!./~/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./src/components/ui/article-snippet.css
// module id = ./node_modules/css-loader/index.js?{"importLoaders":1}!./node_modules/postcss-loader/lib/index.js?{"ident":"postcss","plugins":[null,null]}!./src/components/ui/article-snippet.css
// module chunks = 0